import React from 'react';
import MuiButton, { ButtonProps } from '@material-ui/core/Button';
import cx from 'classnames';
import styles from './Button.module.scss';

// Unified Button Props
export interface IButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'decline' | 'apply' | 'icon' | 'text';
  loading?: boolean;
  label?: string; 
  icon?: React.ReactNode;
}

const Button: React.FC<IButtonProps> = (props) => {
  const {
    children,
    variant = 'primary',
    className,
    fullWidth,
    loading,
    disabled,
    label,
    icon,
    startIcon,
    endIcon,
    ...rest
  } = props;

  const getVariantClass = () => {
    switch (variant) {
      case 'primary': return styles.primaryButton;
      case 'secondary': return styles.secondaryButton; 
      case 'decline': return styles.declineButton;
      case 'apply': return styles.applyButton;
      case 'icon': return styles.iconButton;
      case 'text': return styles.textButton;
      default: return styles.primaryButton;
    }
  };

  const rootClass = cx(
    styles.root,
    getVariantClass(),
    {
      [styles.fullWidth]: fullWidth,
      [styles.loading]: loading,
      [styles.disabled]: disabled,
    },
    className
  );

  const content = children || label;
  const effectiveStartIcon = startIcon || (variant !== 'icon' ? icon : undefined);

  return (
    <MuiButton
      className={rootClass}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      startIcon={effectiveStartIcon}
      endIcon={endIcon}
      disableRipple
      // FIX: Connect SCSS classes to MUI internal elements
      classes={{
        startIcon: styles.startIcon,
        endIcon: styles.endIcon,
        label: styles.contentWrapper // Ensure wrapper styling applies
      }}
      {...rest}
    >
      {loading && <span className={styles.spinner} />}
      
      {!loading && (
        <>
          {variant === 'icon' ? (icon || children) : <span className={styles.text}>{content}</span>}
        </>
      )}
    </MuiButton>
  );
};

export default Button;